module.exports = __webpack_public_path__ + "img/01.4e08abf4.jpg";